import { IRouteInfo } from "@interfaces/i-route-info";
import { ConventinXRPermission, DoctorAssistantPermission, DoctorCarnivitaPermission, DoctorEsomeprazolePermission, GenuphilPermission, HIVAssistantPermission, HIVDoctorPermission, HIVPharmacistPermission, NormalDoctorPermission, RocheDoctorPermission, TreatmentLinesPermission } from "../_constants/permissions";

export class NavigationModel {
  routes: IRouteInfo[];

  constructor() {
    this.routes = [
      {
        path: 'home',
        title: 'Home',
        type: 'link',
        icontype: 'fas fa-home text-primary',
        permission: [NormalDoctorPermission],
        isAssistant: true
      },
      {
        path: 'patientList',
        title: 'Patients List',
        type: 'link',
        icontype: 'fas fa-users text-primary',
        googleAnalyticsKey: 'click_on_patient_list',
        permission: [NormalDoctorPermission],
        isAssistant: true,
      },
      {
        path: 'treatment-lines',
        title: 'Treatment Lines',
        type: 'link',
        icontype: 'assets/img/treatment-lines.png',
        googleAnalyticsKey: 'click_on_treatment_lines',
        permission: [TreatmentLinesPermission],
        isAssistant: false,
      },
      {
        path: 'pep-patient',
        title: 'PEP Patients',
        type: 'link',
        icontype: 'fas fa-users text-primary',
        googleAnalyticsKey: 'click_on_pep_patient',
        permission: [HIVAssistantPermission],
        isAssistant: false,
      },
      {
        path: 'appointments/fullcalendar',
        title: 'Appointments',
        type: 'link',
        icontype: 'fas fa-calendar-check text-primary',
        permission: [NormalDoctorPermission],
        isAssistant: true,
      },
      {
        path: 'carnivita-pms',
        title: 'Carnivita PMS',
        type: 'link',
        icontype: 'ni-briefcase-24 text-primary',
        isAssistant: false,
        permission: [DoctorCarnivitaPermission],
      },
      {
        path: 'esomeprazole-pms',
        title: 'Ramadan Relief Study "RRS"',
        type: 'link',
        icontype: 'ni-briefcase-24 text-primary',
        isAssistant: false,
        permission: [DoctorEsomeprazolePermission]
      },
      {
        path: 'medication-orders',
        title: 'Prescribed Medications',
        type: 'link',
        icontype: 'ni-briefcase-24 text-primary',
        isAssistant: true,
        permission: [DoctorAssistantPermission]
      },
      {
        path: 'stock-transfer',
        title: 'Stock Transfer',
        type: 'link',
        icontype: 'ni-briefcase-24 text-primary',
        isAssistant: true,
        permission: [HIVPharmacistPermission]
      },
      {
        path: 'patient-transfer',
        title: 'Patient Transfer',
        type: 'link',
        icontype: 'ni-briefcase-24 text-primary',
        isAssistant: false,
        permission: [HIVAssistantPermission]
      },
      {
        path: 'pending-prescriptions',
        title: 'Pending Prescriptions',
        type: 'link',
        icontype: 'ni-briefcase-24 text-primary',
        isAssistant: true,
        permission: [HIVDoctorPermission]
      },
      {
        path: 'genuphil-woman-pms',
        title: 'Genuphil Woman',
        type: 'link',
        icontype: 'ni-briefcase-24 text-primary',
        isAssistant: false,
        permission: [GenuphilPermission]
      },
      {
        path: 'conventin-xr-pms',
        title: 'Conventin XR',
        type: 'link',
        icontype: 'ni-briefcase-24 text-primary',
        isAssistant: false,
        permission: [ConventinXRPermission]
      },
      {
        path: 'roche-psp',
        title: 'Roche PSP Enrollment',
        type: 'link',
        icontype: 'ni-briefcase-24 text-primary',
        isAssistant: false,
        permission: [RocheDoctorPermission]
      },
      {
        path: 'drug-drug-interaction',
        title: 'Drug Drug Interaction',
        type: 'link',
        icontype: 'ni-briefcase-24 text-primary',
        googleAnalyticsKey: 'click_on_drug_drug_interaction',
        permission: [NormalDoctorPermission],
        isAssistant: false,
      },
      {
        path: 'assistants-management',
        title: 'Assistants Management',
        type: 'link',
        icontype: 'ni-briefcase-24 text-primary',
        googleAnalyticsKey: '',
        permission: [NormalDoctorPermission],
        isAssistant: false,
      },
      {
        path: 'patients-analysis',
        title: "Patient's Analysis",
        type: 'link',
        icontype: 'ni-briefcase-24 text-primary',
        googleAnalyticsKey: '',
        permission: [NormalDoctorPermission],
        isAssistant: true
      },
      {
        path: 'clinic-finances',
        title: 'Clinic Finances',
        type: 'link',
        icontype: 'fas fa-wallet text-primary',
        googleAnalyticsKey: 'click_on_clinic_finances',
        permission: [NormalDoctorPermission],
        isAssistant: true,
      },
      {
        path: 'clinic-analysis',
        title: 'Clinic Analysis',
        type: 'link',
        icontype: 'fas fa-wallet text-primary',
        googleAnalyticsKey: 'click_on_clinic_analysis',
        permission: [NormalDoctorPermission],
        isAssistant: true,
      },
      {
        path: 'report-problem',
        title: 'Report a problem',
        type: 'btn',
        icontype: 'fas fa-exclamation-triangle text-primary', // Update this with a matching `ni-*` icon class
        isAssistant: true,
      },
    ];
  }
}
